import PropTypes from 'prop-types';
import React from 'react';
import Popover from '@mui/material/Popover';
import { useDefaultComponentValue } from '../utils';
const COMPONENT_NAME = 'MenuPopover';
const MenuPopover = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, sx, ...other } = props;
    return /*#__PURE__*/ React.createElement(Popover, {
        disableScrollLock: true,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
        },
        slotProps: {
            paper: {
                sx: {
                    p: 1,
                    width: 300,
                    overflow: 'auto',
                    ...sx
                }
            }
        },
        ...other
    }, children);
};
MenuPopover.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object
};
export default MenuPopover;
